module.exports = __webpack_public_path__ + "img/graphic.09c71ea5.e7b53cb7.jpg";